import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BrandModal from './components/Modals/BrandModal';
import AuthPage from './routes/AuthPage';
import Dashboard from './routes/Dashboard';
import ProtectedRoute from './routes/ProtectedRoute';

function App() {
  return (
    <>
      <ToastContainer />
      <BrandModal />
      <Routes>
        <Route path="/account" element={<AuthPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<div>Not Found</div>} />
      </Routes>
    </>
  );
}

export default App;
